export const DataTypes = {
    MED: 'ML Medical Team',
    SPO: 'Sports & Performance Team',
    PHY: 'Team Physicians',
    LOC: 'Locations',
    SER: 'Services',
    MOR: 'More',
};

export interface DirectoryVue {
    IsTito: boolean;
    MedTeams: MedTeams[];
    Performance: Performance[];
    Physicians: Physicians[];
    Services: Services[];
    Locations: Locations[];
    DataTypes: typeof DataTypes;
    CurrentType: string;
}

export interface Phone {
    [key: string]: string | undefined;
}
export interface Address {
    [key: string]: string | undefined;
}
export interface MedTeams {
    section?: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    phone?: Phone[];
    email?: string;
    email2?: string;
}
export interface Performance {
    section?: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    phone?: Phone[];
    email?: string;
}
export interface Physicians {
    section?: string;
    speciality?: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    location?: string;
    address?: Address[];
    mapsLink?: string;
    phone?: Phone[];
    email?: string;
    forTito?: boolean;
}
export interface Locations {
    location?: string;
    address?: Address[];
    mapsLink?: string;
    phone?: Phone[];
}
export interface Services {
    location?: string;
    title?: string;
    address?: Address[];
    mapsLink?: string;
    phone?: Phone[];
}
